import React from 'react';
import LegalPage from '../../Commons/LegalPage/LegalPage';
const sections=[{title:"About the consultation fee",content:<><p>
        We are committed to helping applicants from any part of the world access
        the opportunity for education or as visitor or as tourist or as spouse.
        At the same time, we want to ensure we deliver students or as visitor or
        as tourist or as spouse with a high chance of visa approval.
        Accordingly, Space International gives consultation to their clients and
        will collect a mandatory below mentioned consultation fee (the
        “consultation Fee”) from any applicant that contacts Space
        Internationals for any type of consultation (excluding work visa as
        Space Internationals don’t give work visa consultation) any one of the
        following criteria as defined by Space Internationals (which are subject
        to change from time to time in Space Internationals’ sole discretion):
        Space Internationals (Space Visa and International Tours Services
        Private Limited)
      </p></>},
{title:"ONE TIME CONSULTATION FEE: ",content:<><p>For the applicable consultation fee, please contact our team.</p></>},
{title:"PROCESSING FEE:",content:<><p>
        Space Internationals (Space Visa & International Tours Services Private
        Limited), does not charge any fee from their clients to process their
        visa files. Means to say that Space Internationals (Space Visa &
        International Tours Services Private Limited) helps their clients to
        submit their visa file free cost i.e. without payment.
      </p>
      <p>
        Note 1: Space Internationals reserves the right to modify, refund or
        waive the Consultation Fee in its sole discretion for any reason. The
        Processing Fee may be added at any point in the application process in
        Space Internationals’ sole discretion. Your use of the Space
        Internationals Solution following such a requirement and/or change
        constitutes your acceptance of any new or increased charges.
      </p>
      <p>
        Note 2: Space Internationals may also charge a non-refundable deposit
        for certain programs which shall be determined at its sole discretion.
      </p>
      <p>
        Note 3: The consultation Fee does not apply to students who are already
        present in the host country of study and/or present in the host country
        under a current student visa and applying to another program in the same
        country.
      </p>
      <p>
        Note 4: Every student needs to pay application fee of college /
        university as per rules and regulations.
      </p></>},
{title:"Refund Policy",content:<><p>
        Refunds will NOT be issued in any of the following cases: <br />
        An applicant has taken our consultation from our team.
        <br />
        An applicant fails to provide any required document to process the
        application;
        <br />
        An applicant’s visa application is approved, rejected; or banned from
        any country or
        <br />
        An applicant cancels / withdraws his or her application.
        <br />
        If not disqualified from claiming a refund by the above, then the
        consultation Fee may be refunded at Space International’s discretion,
        only if:
        <br />
        The application receives a formal rejection from the institution and any
        application fee paid to institution is refunded by institution for that
        application fee.
      </p></>}];
export default function Refundpolicy(){return <LegalPage title="Consultation Fee" intro="Information about consultation charges, processing fees and the conditions that apply to refunds." company="Space Internationals (Space Visa and International Tours Services Private Limited)" sections={sections} />;}
